<div class="first">
  <div *ngIf="loadingFlight" class="col-12">
    <app-loading [userType]="'user'"></app-loading>
  </div>
  <div class="container-flight">
    <div id="flights-col">
      <ng-container *ngFor="let segmentArr of selectedFlights; let i = index">
        <div class="card-container" id="card-{{ i }}">
          <!-- <div class="card-head">
            <div class="header-title">
              <div class="hangover-button" *ngIf="segmentArr.length > 1" (click)="toggleHanover(i)">
                <p>{{ "flight.detail-flight.see-stops" | translate }}</p>
                <img src="assets/img/svg/flight/down-arrow.svg" alt="down-arrow" />
              </div>
            </div>
            
          </div> -->
          <div class="card-content" style="font-size: smaller;">
            <div class="row" [ngClass]="{ show: seeHangover[i] === true }" style="width: 100%; padding: 1rem 0;">
              <div class="col-2">
                <div class="airline-info">
                  <img [src]="getLogo(segmentArr[0].object.marketing_company)" alt="airlineLogo" />
                  <span class="flight-number">
                    {{ segmentArr[0].object.marketing_company }} {{ segmentArr[0].object.transport_number }}
                  </span>
                  <span class="cabin-class">
                    {{ segmentArr[0].object?.cabin }}
                  </span>
                </div>
              </div>
              <div class="col-3">
                <span class="departure-duration">{{
                  segmentArr[0].object.departure_date | date: "HH:mm"
                  }}</span>
                <span class="departure">
                  {{ segmentArr[0].object.departure }}
                </span>
                <span class="departure-date">{{
                  segmentArr[0].object.departure_date | customDateFormat: "date"
                  }}</span>
              </div>
              <div class="col-4">
                <div class="mainInfoContainer">
                  <div class="stopsContainer">
                    <span>{{ durations[i] }}</span>
                    <div class="LegInfo_stopLine__MzUxZ">
                      <span *ngFor="let i of getStops(segmentArr)" class="LegInfo_stopDot__ZTAyN"></span><svg
                        id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 12 12" enable-background="new 0 0 12 12" xml:space="preserve"
                        class="LegInfo_planeEnd__ZDkxM">
                        <path fill="#898294"
                          d="M3.922,12h0.499c0.181,0,0.349-0.093,0.444-0.247L7.949,6.8l3.233-0.019C11.625,6.791,11.989,6.44,12,6 c-0.012-0.44-0.375-0.792-0.818-0.781L7.949,5.2L4.866,0.246C4.77,0.093,4.602,0,4.421,0L3.922,0c-0.367,0-0.62,0.367-0.489,0.71 L5.149,5.2l-2.853,0L1.632,3.87c-0.084-0.167-0.25-0.277-0.436-0.288L0,3.509L1.097,6L0,8.491l1.196-0.073 C1.382,8.407,1.548,8.297,1.632,8.13L2.296,6.8h2.853l-1.716,4.49C3.302,11.633,3.555,12,3.922,12">
                        </path>
                      </svg>
                    </div>
                    <div class="stopsLabelContainer" *ngIf="segmentArr.length - 1 > 0" (click)="toggleHanover(i)">
                      {{ segmentArr.length - 1 }}
                      {{ "flight.detail-flight.stops" | translate }}
                      <img src="assets/img/svg/flight/down-arrow.svg" alt="down-arrow" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <span class="arrival-duration">{{
                  segmentArr[segmentArr.length - 1].object.arrival_date
                  | date: "HH:mm"
                  }}</span>
                <span class="arrival">{{
                  segmentArr[segmentArr.length - 1].object.arrival
                  }}</span>
                <span class="arrival-date">{{
                  segmentArr[segmentArr.length - 1].object.arrival_date
                  | customDateFormat: "date"
                  }}</span>
              </div>
            </div>
            <!-- <div class="card-foot" [ngClass]="{ double: canBaggage }">
              <div ngbDropdown class="dropdown-container my-dropdown select-input form-control"
                *ngIf="canBaggage && baggagesInfo && baggagesInfo.length > 0">
                <div ngbDropdownToggle class="dropdown-toggle cursor-pointer">
                  {{
                  !selectedBags ||
                  !selectedBags.length > 0 ||
                  !selectedBags[i]
                  ? ("flight.detail-flight.baggageSelection" | translate)
                  : selectedBags[i].short_name
                  ? selectedBags[i].short_name
                  : ("train.none" | translate)
                  }}
                </div>
                <div ngbDropdownMenu class="dropdown-menu border-radius-20" aria-labelledby="dropdownBasic1">
                  <p ngbDropdownItem (click)="selectBaggage(i, -1)">
                    -- {{ "train.none" | translate }} --
                  </p>
                  <ng-container *ngFor="
                      let bag of getBaggagesInfo(segmentArr);
                      let index = index
                    ">
                    <p ngbDropdownItem *ngIf="
                        bag.seg_references[0] === segmentArr[i]
                          ? segmentArr[i].id
                          : segmentArr[0].id &&
                            bag.category?.toLowerCase() !== 'seatmap'
                      " (click)="selectBaggage(i, bag)" [ngClass]="{
                        last: baggagesInfo.length - 1 === i
                      }">
                      {{ bag.short_name }}: +{{ bag.total }}€
                    </p>
                  </ng-container>
                </div>
              </div>
            </div> -->
          </div>
          <div class="card-content" style="font-size: smaller;">
            <div class="row hangovers" style="width: 100%; margin: 1rem; padding: 1rem 0;"
              *ngIf="segmentArr.length > 1 && seeHangover[i] === true">
              <ng-container *ngFor="let hangover of segmentArr | slice: 1:segmentArr.length">
                <div class="col-2">
                  <div class="airline-info">
                    <img [src]="getLogo(hangover.object.marketing_company)" alt="airlineLogo" />
                    <span class="flight-number">
                      {{
                      hangover.object
                      .marketing_company
                      }}
                      {{
                      hangover.object
                      .transport_number
                      }}
                    </span>
                    <span class="cabin-class">
                      {{ hangover.object?.cabin }}
                    </span>
                  </div>
                </div>
                <div class="col-3">
                  <span class="departure-duration">{{
                    hangover.object.departure_date | date: "HH:mm"
                    }}</span>
                  <span class="departure">
                    {{ this.departureName }}{{ hangover.object.departure }}
                  </span>
                  <span class="departure-date">{{
                    hangover.object.departure_date | customDateFormat: "date"
                    }}</span>
                </div>
                <div class="col-4">
                  <div class="mainInfoContainer">
                    <div class="stopsContainer">
                      <div class="stopsLabelContainer"></div>
                      <div class="LegInfo_stopLine__MzUxZ"></div>
                      <div class="stopsLabelContainer"></div>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <span class="arrival-duration">{{
                    hangover.object.arrival_date | date: "HH:mm"
                    }}</span>
                  <span class="arrival">{{ hangover.object.arrival }}</span>
                  <span class="arrival-date">{{
                    hangover.object.arrival_date | customDateFormat: "date"
                    }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div id="extras-col">
      <div id="baggage-container" [class.expanded]="isBaggageExpanded">
        <div class="baggage-header" (click)="toggleBaggageContainer()">
          <h6>{{ "flight.detail-flight.add-bag" | translate }}</h6>
          <img src="assets/img/svg/arrow-down.svg" [style.transform]="isBaggageExpanded ? 'rotate(180deg)' : ''"
            alt="toggle-arrow" />
        </div>
        <div class="baggage-content-container" *ngIf="isBaggageExpanded && !canBaggage">
          {{ "flight.detail-flight.no-baggage-options" | translate }}
        </div>
        <div class="baggage-content-container" *ngIf="isBaggageExpanded && canBaggage">
          <div class="baggage-section" *ngFor="let passenger of selectedUsers; let i = index"
            [class.expanded]="isPassengerExpanded[i]">
            <div class="passenger-header" (click)="togglePassenger(i)">
              <h5 class="passenger-header-content">
                <span class="passenger-number">{{ i + 1 }}</span>
                {{ passenger.name }} {{ passenger.lastname }}
              </h5>
              <img src="assets/img/svg/arrow-down.svg" [style.transform]="isPassengerExpanded[i] ? 'rotate(180deg)' : ''"
                alt="toggle-arrow" />
            </div>

            <div class="baggage-content" [class.open]="isPassengerExpanded[i]"
              [@accordion]="isPassengerExpanded[i] ? 'open' : 'closed'">
              <ng-container *ngFor="let segmentArr of selectedFlights; let segIndex = index">
                <div class="flight-section"
                  *ngIf="getBaggagesInfo(segmentArr, segIndex === 0 ? 'outward' : 'return', i).length > 0">
                  <h6 class="uppercase">
                    {{ (segIndex === 0 ? 'flight.form-flight.outward' : 'flight.form-flight.return') | translate }}
                  </h6>
                  <div class="baggage-list">
                    <ng-container
                      *ngFor="let bag of getBaggagesInfo(segmentArr, segIndex === 0 ? 'outward' : 'return', i)">
                      <div class="baggage-item"
                        [ngClass]="{ 'selected-baggage': isBagSelectedMultiple(passenger.uuid, segmentArr[0]?.id, bag) }">
                        <img src="assets/img/svg/project.svg" alt="baggage-icon" />
                        <div class="baggage-info">
                          <p>{{ bag.short_name }}</p>
                          <p>{{ bag.total }} EUR</p>
                        </div>
                        <button class="add-baggage-button"
                          (click)="toggleBagSelectionMultiple(i, segmentArr[0]?.id, bag, !isBagSelectedMultiple(passenger.uuid, segmentArr[0]?.id, bag))">
                          {{ isBagSelectedMultiple(passenger.uuid, segmentArr[0]?.id, bag) ? ('flight.detail-flight.added'
                          |
                          translate) : ('flight.detail-flight.add' | translate) }}
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <div class="flight-section" *ngIf="getBaggagesInfo(selectedFlights, 'both', i).length > 0">
                <h6 class="uppercase">{{ "flight.form-flight.round-trip" | translate }}</h6>
                <div class="baggage-list">
                  <ng-container *ngFor="let bag of getBaggagesInfo(selectedFlights, 'both', i)">
                    <div class="baggage-item"
                      [ngClass]="{ 'selected-baggage': isBagSelectedMultiple(passenger.uuid, 'both', bag) }">
                      <img src="assets/img/svg/project.svg" alt="baggage-icon" />
                      <div class="baggage-info">
                        <p>{{ bag.short_name }}</p>
                        <p>{{ bag.total }} EUR</p>
                      </div>
                      <button class="add-baggage-button"
                        (click)="toggleBagSelectionMultiple(i, 'both', bag, !isBagSelectedMultiple(passenger.uuid, 'both', bag))">
                        {{ isBagSelectedMultiple(passenger.uuid, 'both', bag) ? ('flight.detail-flight.added' | translate)
                        :
                        ('flight.detail-flight.add' | translate) }}
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="priority-container" [class.expanded]="isPriorityExpanded" *ngIf="canPriority">
        <div class="baggage-header" (click)="togglePriorityContainer()">
          <h6>{{ "flight.detail-flight.priority" | translate }}</h6>
          <img
            src="assets/img/svg/arrow-down.svg"
            [style.transform]="isPriorityExpanded ? 'rotate(180deg)' : ''"
            alt="toggle-arrow"
          />
        </div>

        <div class="baggage-content-container" *ngIf="isPriorityExpanded">
          <div
            class="baggage-section"
            *ngFor="let passenger of selectedUsers; let i = index"
            [class.expanded]="isPriorityPassengerExpanded[i]"
          >
            <div class="passenger-header" (click)="togglePriorityPassenger(i)">
              <h5 class="passenger-header-content">
                <span class="passenger-number">{{ i + 1 }}</span>
                {{ passenger.name }} {{ passenger.lastname }}
              </h5>
              <img
                src="assets/img/svg/arrow-down.svg"
                [style.transform]="isPriorityPassengerExpanded[i] ? 'rotate(180deg)' : ''"
                alt="toggle-arrow"
              />
            </div>

            <div
              class="baggage-content"
              [class.open]="isPriorityPassengerExpanded[i]"
              [@accordion]="isPriorityPassengerExpanded[i] ? 'open' : 'closed'"
            >
              <ng-container *ngFor="let segmentArr of selectedFlights; let segIndex = index">
                <div
                  class="flight-section"
                  *ngIf="getPriorityInfo(segmentArr, segIndex === 0 ? 'outward' : 'return', i).length > 0"
                >
                  <h6 class="uppercase">
                    {{ (segIndex === 0 ? 'flight.form-flight.outward' : 'flight.form-flight.return') | translate }}
                  </h6>

                  <div class="baggage-list">
                    <ng-container *ngFor="let prio of getPriorityInfo(segmentArr, segIndex === 0 ? 'outward' : 'return', i)">
                      <div
                        class="baggage-item"
                        [ngClass]="{ 'selected-baggage': isPrioritySelectedMultiple(passenger.uuid, segmentArr[0]?.id, prio) }"
                      >
                        <img src="assets/img/svg/project.svg" alt="priority-icon" />
                        <div class="baggage-info">
                          <p>{{ prio.short_name }}</p>
                          <p>{{ prio.total }} EUR</p>
                        </div>

                        <button
                          class="add-baggage-button"
                          (click)="togglePrioritySelectionMultiple(
                            i,
                            segmentArr[0]?.id,
                            prio,
                            !isPrioritySelectedMultiple(passenger.uuid, segmentArr[0]?.id, prio)
                          )"
                        >
                          {{
                            isPrioritySelectedMultiple(passenger.uuid, segmentArr[0]?.id, prio)
                              ? ('flight.detail-flight.added' | translate)
                              : ('flight.detail-flight.add' | translate)
                          }}
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <div *ngIf="
                getPriorityInfo(selectedFlights[0], 'outward', i).length === 0 &&
                (selectedFlights.length < 2 || getPriorityInfo(selectedFlights[1], 'return', i).length === 0)
              " style="font-size: 0.8rem; color: #6f6f6f; padding: 0.5rem 0;">
                {{ "flight.detail-flight.no-priority-options" | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="price-col">
      <mat-accordion>
        <mat-expansion-panel [expanded]="!accomInfo">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ "flight.flight-info" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div id="details-container">
            <span *ngIf="canUseResident" class="resident-applied">{{ 'flight.resident-applied' | translate }}</span>
            <div class="details-buy-text" [ngClass]="{ 'no-fare': fareSelected == null }">
              <ng-container *ngIf="fareSelected && farePricing">
                <ng-container *ngIf="company?.showCommissions || isEmployee; else sinComisiones">
                  <div class="buy-text">
                    <div>
                      <div *ngIf="needsAuthorizationDetail()"
                        style="display: flex; justify-content: center;">
                        <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
                      </div>
                    </div>
                    <div *ngIf="fareSelected && farePricing">
                      <div class="total-price base-price">
                        <p>{{ "hotel.base-rate" | translate }}:</p>
                        <p>{{ farePricing.amount | price }} €</p>
                      </div>
                      <div class="total-price fee-emit">
                        <p>{{ "flight.result-flight.fee-emit" | translate }}:</p>
                        <p>{{ (farePricing.total - farePricing.amount) | price }} €</p>
                      </div>
                      <div class="total-price baggage-price" *ngIf="selectedBags?.length > 0">
                        <p>{{ "my-bookeds.flight.baggage" | translate }} ({{ getBaggagesNumber() }}):</p>
                        <p>{{ getTotalBaggagePrice() | price }} €</p>
                      </div>
                      <div class="total-price priority-price" *ngIf="selectedPriority?.length > 0">
                        <p>
                          {{ "flight.detail-flight.priority" | translate }}
                          ({{ getPriorityNumber() }}):
                        </p>
                        <p>{{ getTotalPriorityPrice() | price }}&nbsp;€</p>
                      </div>
                      <div class="total-price total-price-label">
                        <p>{{ "flight.result-flight.total-price" | translate }}:</p>
                        <p>{{ totalPrice | price }} €</p>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-template #sinComisiones>
                  <div class="buy-text">
                    <div class="total-price base-price">
                      <p>{{ "hotel.base-rate" | translate }}:</p>
                      <p>{{ (totalPrice - getTotalBaggagePrice()) | price }} €</p>
                    </div>

                    <div *ngIf="selectedBags?.length > 0" class="total-price baggage-price">
                      <p>{{ "my-bookeds.flight.baggage" | translate }} ({{ getBaggagesNumber() }}):</p>
                      <p>{{ getTotalBaggagePrice() | price }} €</p>
                    </div>

                    <div class="total-price total-price-label">
                      <p>{{ "flight.result-flight.total-price" | translate }}:</p>
                      <p>{{ totalPrice | price }} €</p>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </div>
          <hr style="margin: 0;">
          <span style="font-size: small;font-weight: 600;padding: 0 0.7rem;">{{ "flight.detail-flight.cabin-baggage" |
            translate }}</span>
          <div class="fare-includes">
            <div>
              <span>{{ "flight.form-flight.outward" | translate }}</span>
              <span *ngIf="selectedFlights.length > 1">{{ "flight.form-flight.return" | translate }}</span>
            </div>
            <div *ngIf="fareSelected">
              <span>{{ getIncludesFare('HandBaggage', 0) | translate }}</span>
              <span *ngIf="selectedFlights.length > 1">{{ getIncludesFare('HandBaggage', 1) | translate }}</span>
            </div>
          </div>
          <hr style="margin: 0;">
          <span style="font-size: small;font-weight: 600;padding: 0 0.7rem;">{{ "flight.detail-flight.checked-baggage" |
            translate }}</span>
          <div class="fare-includes">
            <div>
              <span>{{ "flight.form-flight.outward" | translate }}</span>
              <span *ngIf="selectedFlights.length > 1">{{ "flight.form-flight.return" | translate }}</span>
            </div>
            <div *ngIf="fareSelected">
              <span>{{ getIncludesFare('Baggage', 0) | translate }}</span>
              <span *ngIf="selectedFlights.length > 1">{{ getIncludesFare('Baggage', 1) | translate }}</span>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion *ngIf="accomInfo" style="margin-top: 1rem;">
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ "hotel.accom-info" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <div *ngIf="accomInfo.needsAuth"
              style="display: flex; justify-content: center;">
              <span class="admin-permission-msg">{{ "authorization.permissions-required" | translate }}</span>
            </div>
            <div class="room" *ngFor="let room of accomInfo.selectedRooms; let j = index">
              <p style="font-weight: 600;">{{ "hotel.room" | translate}} {{j + 1}}: {{room.name}}</p>
              <div class="total-price base-price" *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
                <p>{{ "hotel.base-rate" | translate }}: </p>
                <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
              </div>
              <div class="total-price base-price" *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) !== 'E'">
                <p *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0" style="color: #f46f69"
                  matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                  "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
                <p>{{room.rates[0].price.fees.amount | price }}€</p>
              </div>
              <div class="total-price base-price" *ngIf="room.rates[0].price && accomInfo.hotel.code.charAt(0) === 'E'">
                <p *ngIf="room.rates[0].price.baseRate && room.rates[0].price.baseRate.amount > 0">{{
                  "hotel.base-rate" | translate }}: </p>
                <p>{{ room.rates[0].price.baseRate.amount | price }}€</p>
              </div>
              <div class="total-price base-price"
                *ngIf="room.rates[0].price.taxAndServiceFee && room.rates[0].price.taxAndServiceFee.amount > 0">
                <p matTooltip="{{ 'hotel.taxes-and-fees-details' |translate }}">{{ "hotel.taxes-and-fees" |
                  translate }} <i class="fa fa-question-circle"></i>: </p>
                <p>{{ room.rates[0].price.taxAndServiceFee.amount | price }}€</p>
              </div>
              <div class="total-price base-price"
                *ngIf="room.rates[0].price.salesTax && room.rates[0].price.salesTax.amount > 0">
                <p>{{
                  "hotel.sales-tax" | translate }}: </p>
                <p>{{ room.rates[0].price.salesTax.amount | price }}€</p>
              </div>
              <div class="total-price base-price"
                *ngIf="room.rates[0].price.fees && room.rates[0].price.fees.amount > 0">
                <p style="color: #f46f69" matTooltip="{{ 'hotel.due-at-property-details' |translate }}">{{
                  "hotel.due-at-property" | translate }} <i class="fa fa-question-circle"></i>: </p>
                <p>{{ room.rates[0].price.fees.amount | price }}€</p>
              </div>
              <div class="total-price base-price" *ngIf="room.rates[0].price && room.rates[0].price.totalPrice.total">
                <p>{{ "search.search-booked.total-price-by-room" | translate }}: </p>
                <p>{{ room.rates[0].price.totalPrice.total | price }}€</p>
              </div>
            </div>
            <div class="total-price total-price-label">
              <p>{{ "search.search-booked.total-price" | translate }}: </p>
              <p>{{ getTotalPriceAccom() | price }}€</p>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="total-price total-price-label" *ngIf="accomInfo">
        <p>{{ "hotel.total-price-package" | translate }}: </p>
        <p>{{ getTotalPackage() | price }} €</p>
      </div>
      <div id="details-container">
        <button class="custom-btn" (click)="goNextStep()">
          {{ "flight.result-flight.continue" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>